module.exports = __webpack_public_path__ + "media/images/pasta-5fbb783da80b03001808df8f8bccc139.png";